import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../../assets/award1.png";
import img2 from "../../assets/award2.png";
import img3 from "../../assets/award3.png";
import img4 from "../../assets/award4.png";
import img5 from "../../assets/award5.png";
import img6 from "../../assets/award6.png";
import img7 from "../../assets/award7.png";
import img8 from "../../assets/award8.png";

const journeyData = [
  {
    year: "2010",
    title: "Butterfly Consulting was born",
    description:
      "Launched as a specialized HR consulting and training firm focused on IT startups and mid-sized companies.",
  },
  {
    year: "2018",
    title: "Butterfly Decors took flight",
    description:
      "Expanded into interior design and decor services, adding a creative touch to homes and workplaces.",
  },
  {
    year: "2020",
    title: "Butterfly Constructions was established",
    description:
      "Marked a new milestone by venturing into residential and commercial construction services.",
  },
  {
    year: "2024",
    title: "Butterfly Wellness emerged",
    description:
      "Introduced holistic wellness services under Butterfly Wellness Clinic to promote mental and emotional well-being.",
  },
];

const Journey = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section  data-aos="fade-up" className="w-full px-4 sm:px-6 py-12 sm:py-16 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl md:text-[40px] font-bold text-[#172633] mb-8 uppercase">
          BUTTERFLY’S JOURNEY
        </h1>

        <div className="relative flex flex-col items-center">
          {/* Vertical line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[2px] h-full bg-[#5CCEC4]"></div>

          {journeyData.map((item, index) => (
            <div
              key={index}
              className="relative z-10 mb-10 sm:mb-16 flex flex-col items-center"
            >
              {/* Year circle */}
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-white border-2 border-teal-500 rounded-full shadow-md">
                <span className="text-xs sm:text-sm font-bold text-teal-600">
                  {item.year}
                </span>
              </div>

              {/* Gradient card */}
              <div className="mt-4 sm:mt-6 bg-gradient-to-r from-[#62C2BA] to-[#00948B] text-white rounded-full shadow-lg px-4 sm:px-8 py-4 sm:py-6 max-w-xs sm:max-w-lg">
                <h3 className="text-sm sm:text-lg font-semibold">{item.title}</h3>
                <p className="mt-1 sm:mt-2 text-xs sm:text-sm">{item.description}</p>
              </div>
            </div>
          ))}

          {/* End portion */}
          <div className="flex flex-col items-center relative z-10">
            {/* Small vertical line before circle */}
            <div className="w-[2px] h-4 sm:h-6 bg-[#5CCEC4]"></div>

            {/* End circle */}
            <div className="w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-gradient-to-r from-[#62C2BA] to-[#00948B]"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;
